import React, { useContext } from "react";
import {
  SpreadsheetContext,
} from "@gistapps/composite-spreadsheet";
import type {
  DataEditorProps,
} from "@gistapps/composite-spreadsheet";

export type DropdownOption = {
  value: string | number | null;
  name: string;
};

type Props = DataEditorProps & {
  options: DropdownOption[];
};

const DropdownCellEditor = ({
  cell,
  column,
  row,
  exitEditMode,
  options,
}: Props) => {

  const {
    updateSpreadsheetCellData,
  } = useContext(SpreadsheetContext);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    updateSpreadsheetCellData(row, column, { value: e.target.value }, true);
    exitEditMode();
  };

  return (
    <select
      className="gc__table-dropdown-editor"
      defaultValue={(cell?.value as string) ?? ""}
      onChange={handleChange}
      autoFocus
    >
      {options.map((opt) => (
        <option
          key={String(opt.value ?? "")}
          value={String(opt.value ?? "")}
        >
          {opt.name}
        </option>
      ))}
    </select>
  );

};

export default DropdownCellEditor;
